import { unloadedAsyncState } from "widgets-for-react";
export const initialCollectionItemDetailsState = {
    route: '/aanbod',
    itemId: null,
    item: unloadedAsyncState(),
    recommendations: unloadedAsyncState(),
    preferredBranchId: ''
};
